<div [style.width.px]="resourcesColumnWidthPx">
  <nz-select
    class="mt-2 ms-2 me-3 select-width"
    nzAllowClear
    nzShowSearch
    nzMode="tags"
    [nzMaxTagCount]="1"
    [nzPlaceHolder]="'general.filter' | translate"
    [ngModel]="selectedUnassignedFilter"
    (ngModelChange)="setUnassignedServicesFilter($event)"
  >
    @for (option of unassignedServices; track option) {
      <nz-option [nzLabel]="option.name" [nzValue]="option.id"></nz-option>
    }
  </nz-select>
</div>
